module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BGMd82/images/9781626560758.jpg?1736602766558",
      "alt": "This image is the cover for the book Social Labs Revolution"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Social Labs Revolution\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Current responses to our most pressing societal challenges‚Äîfrom poverty to ethnic conflict to climate change‚Äîare not working. These problems are incredibly dynamic and complex, involving an ever-shifting array of factors, actors, and circumstances. They demand a highly fluid and adaptive approach, yet we address them by devising fixed, long-term plans. Social labs, says Zaid Hassan, are a dramatically more effective response. "), _c('br'), _c('br'), _vm._v("Social labs bring together a diverse a group of stakeholders‚Äînot to create yet another five-year plan but to develop a portfolio of prototype solutions, test those solutions in the real world, use the data to further refine them, and test them again. Hassan builds on a decade of experience‚Äîas well as drawing from cutting-edge research in complexity science, networking theory, and sociology‚Äîto explain the core principles and daily functioning of social labs, using examples of pioneering labs from around the world. He offers a new generation of problem solvers an effective, practical, and exciting new vision and guide.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Zaid Hassan, Joi Ito\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Berrett–Koehler\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0